import React from 'react';
import { useSelector } from 'react-redux';
import Button from '@mui/material/Button';
import MapIcon from '@mui/icons-material/Map';
import Tooltip from '@mui/material/Tooltip';
import { useNavigate } from "react-router-dom";

const MapButton = () => {

    const pdfPrintData = useSelector(state => state.showRefState.pdfPrintData);
    const referencesData = useSelector(state => state.searchRefState.referencesData);
    const navigate = useNavigate();

    const handleClick = () => {
        navigate('/viewMap');
    };

    return (
        <div>
            <Tooltip placement="left" title={<h6 style={{ color: "white" }}>Show Map</h6>}>
                <Button
                    style={{ width: 80, backgroundColor: 'rgba(26, 26, 238, 0.54)', marginBottom: 10, marginTop: 5 }}
                    onClick={() => (pdfPrintData || referencesData) && handleClick()}
                    variant="contained"
                    size="large"
                    color="primary"
                    startIcon={<MapIcon style={{ color: 'white' }} />}
                />
            </Tooltip>
        </div>
    );
};

export default MapButton;